import { createFileRoute } from "@tanstack/react-router";
import { DatacentrePage, datacentreHead } from "@/pages/DatacentrePage";

export const Route = createFileRoute("/brancher/datacentre")({
  head: () => datacentreHead("da"),
  component: () => <DatacentrePage locale="da" />,
});
